/* eslint-disable no-var */
var evs = require("event-source-polyfill");

module.exports = evs.EventSourcePolyfill;
